// extracted by mini-css-extract-plugin
export default {"card":"H6-z"};